import { render, staticRenderFns } from "./ArticleView.vue?vue&type=template&id=0f7fafce&"
import script from "./ArticleView.vue?vue&type=script&lang=js&"
export * from "./ArticleView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleView.vue?vue&type=style&index=0&id=0f7fafce&prod&lang=css&"
import style1 from "./ArticleView.vue?vue&type=style&index=1&id=0f7fafce&prod&lang=scss&"
import style2 from "./ArticleView.vue?vue&type=style&index=2&id=0f7fafce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports